import { fetchGeoLocationsByIds, getGeoLocationByUrlName } from '@/api/geoService';
import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { geoIdToRouteLocationMapping, routeLocationToGeoIdMapping } from '@/types';
import { HgSupportedLanguage } from '@smg-real-estate/domus/types';

export const getDesiredRoute = async (
  urlName: string,
  language: HgSupportedLanguage,
): Promise<string | undefined> => {
  const geoLocation = await getGeoLocationByUrlName(urlName, language);
  if (!geoLocation || geoLocation.type !== 'municipality') {
    return undefined;
  }

  const locationName = geoIdToRouteLocationMapping[geoLocation.id];
  if (!locationName) {
    return undefined;
  }

  const desiredCantonGeoId = routeLocationToGeoIdMapping[locationName];
  const cantonGeoLocation = await fetchGeoLocationsByIds([desiredCantonGeoId]);
  if (!cantonGeoLocation?.length) {
    return undefined;
  }

  return isPlatformIs24()
    ? cantonGeoLocation[0].is24UrlNames?.[language]
    : cantonGeoLocation[0].urlNames?.[language];
};
